import React from "react";
import Input from "../../Components/Password";
import Button from '../../Components/Button'
import Messages from '../../Components/Messages'
import http from "../../Api/http";
import ProgressSpinner from '../../Components/ProgressSpinner'
import Dialog from '../../Components/Dialog';
import Util from '../../Util'

const $ = window.$;
const stringHash = require('@sindresorhus/string-hash');

export default class MCPwd extends React.Component {

    constructor(props) {
        super(props);
        this.hash = null
        this.state = {
            loading: true,
            mode: 'new',
            formErrors: { newPwd: '', confirmPwd: '' },
            isDesktop: window.innerWidth > 1250,
            visibleDialog: false,
            empCode: localStorage.getItem("useridHR"),
            newPwd: '',
            confirmPwd: ''
        }
    }

    updatePredicate = () => {
        return window.innerWidth > 1250
    }

    componentDidMount = async () => {
        let _isDesktop = this.updatePredicate();
        this.setState({ isDesktop: _isDesktop, loading: false })
    }

    hashState = () => {
        let newHash = stringHash(JSON.stringify(this.state))
        return newHash
    }

    handleUserInput = (e) => {
        const name = e.target.id;
        const value = e.target.value;

        this.setState({ [name]: value })
    }

    validateField() {

        let fieldValidationErrors = this.state.formErrors;

        let _newPwd = this.state.newPwd;
        fieldValidationErrors.newPwd = _newPwd ? '' : $.strings.requiredFiled;

        let _confirmPwd = this.state.confirmPwd;
        fieldValidationErrors.confirmPwd = _confirmPwd ? '' : $.strings.requiredFiled;

        if (_confirmPwd + "" !== _newPwd + "") {
            _confirmPwd = undefined
            fieldValidationErrors.confirmPwd = $.strings.confirmPwdError
        }
        this.setState({
            formErrors: fieldValidationErrors,
            newPwdValid: _newPwd,
            confirmPwdValid: _confirmPwd,
        }, this.validateForm);

        return _newPwd && _confirmPwd;
    }
    validateForm() {
        let isFormValid = this.state.newPwdValid && this.state.confirmPwdValid
        this.setState({ formValid: isFormValid });
        return isFormValid
    }

    render() {
        const footer = (
            <div style={{ textAlign: 'center' }}>
                <Button label={$.strings.save} icon="" className="p-button-success" onClick={this.onSave}>
                    &nbsp;&nbsp;
                    <i className="pi pi-check" />
                </Button>
                <Button label={$.strings.cancel} icon="" className="p-button-danger" onClick={this.onHide}>
                    &nbsp;&nbsp;
                    <i className="pi pi-times" />
                </Button>
            </div>
        );

        const myIcon = (
            <button className="p-dialog-titlebar-icon p-link">
            </button>
        )
        return (
            <div>
                <ProgressSpinner loading={this.state.loading} />
                <Dialog header={$.strings.changePassword} footer={footer} icons={myIcon} visible={this.state.visibleDialog}
                    style={{ width: this.state.isDesktop ? '20vw' : '80vw', direction: $.strings.dir }}
                    modal onHide={this.onHide}>
                    <div ref="divMain" >
                        <div className="p-grid">
                            {$.strings.mCPwdHint}
                        </div>
                        <hr />
                        <div className="p-grid">
                            <div className="p-col-12 p-lg-12 p-sm-12">
                                <Input
                                    innerRef={(el) => this.txtNewPwd = el}
                                    type="text"
                                    id="newPwd"
                                    inputId="newPwd"
                                    maxLength="16"
                                    value={this.state.newPwd || ''}
                                    autocomplete="off"
                                    onChange={this.handleUserInput}
                                    caption={$.strings.newPwd}
                                    isrequired={true}
                                    formErrors={this.state.formErrors}
                                    feedback={false}
                                />
                            </div>
                        </div>
                        <div className="p-grid">
                            <div className="p-col-12 p-lg-12 p-sm-12">
                                <Input
                                    innerRef={(el) => this.txtConfirmPwd = el}
                                    type="text"
                                    id="confirmPwd"
                                    inputId="confirmPwd"
                                    maxLength="16"
                                    value={this.state.confirmPwd || ''}
                                    autocomplete="off"
                                    onChange={this.handleUserInput}
                                    caption={$.strings.confirmNewPwd}
                                    isrequired={true}
                                    formErrors={this.state.formErrors}
                                    feedback={false}
                                />
                            </div>
                        </div>
                    </div >
                </Dialog >
            </div>
        );
    }
    show = () => {
        this.setState({
            visibleDialog: true, newPwd: '', confirmPwd: '',
            formErrors: { newPwd: '', confirmPwd: '' },
        }, () => setTimeout(() => { this.txtNewPwd.container.firstChild.focus() }, 10));
    }

    onHide = () => {
        this.setState({
            visibleDialog: false, newPwd: '', confirmPwd: '',
            formErrors: { newPwd: '', confirmPwd: '' }
        }, () => {
            localStorage.setItem("isLoggedIn", false);
            localStorage.setItem("useridHR", undefined);
        })
        //Util.goTo("/login", "");
    }

    onSave = async () => {
        
        if (Util.checkISHR()) {
            await this.changePasswordHR();
        }
        else {
            await this.changePassword();
        }
    }

    changePassword = async () => {
        if (!this.validateField()) {
            this.setState({ loading: false })
            return false;
        }
        this.setState({ loading: true })

        let obj = {
            empCode: localStorage.getItem("useridHR"),
            oldPwd: '',
            newPwd: this.state.newPwd
        }

        let saveResult
        let res = await http.getJsonAxios(http.actions.Employee.urlMustChangePassword, obj, 0);
        if (res.status === 200) {
            if (res.data.success) {
                this.setState({ loading: false, visibleDialog: false }, () => Util.goTo('/'))
                return saveResult = true
            }
            else {
                if (res.data.errorText !== "") {
                    alert(res.data.errorText);
                    this.txtNewPwd.container.firstChild.focus()
                    this.setState({ loading: false })
                    return saveResult = false
                }
                else {
                    alert($.strings.operationFailed);
                    this.txtNewPwd.container.firstChild.focus()
                    this.setState({ loading: false })
                    return saveResult = false
                }
            }
        }
        else {
            if (res.data.errorText !== "") {
                alert(res.data.errorText);
                this.setState({ loading: false })
                return saveResult = false
            }
            else {
                alert($.strings.operationFailed);
                this.setState({ loading: false })
                return saveResult = false
            }
        }
    }

    changePasswordHR = async () => {
        if (!this.validateField()) {
            this.setState({ loading: false })
            return false;
        }
        this.setState({ loading: true })

        let obj = {
            userId: localStorage.getItem("useridHR"),
            oldPassword: '',
            newPassword: Util.encryptStringToHexa(this.state.newPwd),
            confirmPassword: Util.encryptStringToHexa(this.state.confirmPwd)
        }
        
        let saveResult
        let res = await http.postMultipartAxios(http.actions.Employee.urlPostResetPasswordHR, obj, 0);
        if (res.status === 200) {
            if (res.data.success) {
                localStorage.setItem("isLoggedInHR", Util.encryptStringToHexa(this.state.newPwd))
                this.setState({ loading: false, visibleDialog: false }, () => Util.goTo('/HandleRequests'))
                return saveResult = true
            }
            else {
                if (res.data.errorText !== "") {
                    alert(res.data.errorText);
                    this.txtNewPwd.container.firstChild.focus()
                    this.setState({ loading: false })
                    return saveResult = false
                }
                else {
                    alert($.strings.operationFailed);
                    this.txtNewPwd.container.firstChild.focus()
                    this.setState({ loading: false })
                    return saveResult = false
                }
            }
        }
        else {
            if (res.data.errorText !== "") {
                alert(res.data.errorText);
                this.setState({ loading: false })
                return saveResult = false
            }
            else {
                alert($.strings.operationFailed);
                this.setState({ loading: false })
                return saveResult = false
            }
        }
    }
}